import React from 'react';

import EntityViewer from '../entity-viewer/EntityViewer';

import { TestID } from '../../testID';

import type { Pipe } from '../../types/pipes.types';

import './PipeInput.css';

export const SourceEntities: React.FC<{ pipe: Pipe }> = ({ pipe }) => (
  <div data-testid={TestID.PipeInputSourceEntities} className="pipe-input">
    <div className="pipe-input__description">
      <h1 className="heading-page">Source entities</h1>
      <p>This is how the entities look as they come out of the source.</p>
    </div>
    <div className="pipe-input__content">
      <EntityViewer pipe={pipe} stage="source" />
    </div>
  </div>
);
